import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-features',
  templateUrl: './app-features.component.html',
  styleUrls: ['./app-features.component.scss']
})
export class AppFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
